import React, { Component } from "react";
import PropTypes from "prop-types";

import Lottie from "lottie-react";
import brandStyles from "./LoyaltyRewardBrandRefresh.module.css";
import legacyStyles from "./LoyaltyReward.module.css";
import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";

import * as loyaltyRepo from "../../shared/repos/graphql/loyalty";
import * as notificationRepo from "../../shared/repos/graphql/customerNotifications";
import Loader from "../../components/Loader/Loader";
import LoyaltyCard from "./LoyaltyCard";

const mapPinAnimation = require("./imgs/location.json");

const hasMetricValue = value => value !== null && value !== undefined && value !== "";

const getMetricDisplayValue = metrics => {
  if (hasMetricValue(metrics.value)) {
    return metrics.value;
  }
  if (metrics.type === "money_saved") {
    return "$0";
  }
  return 0;
};

class LoyaltyPointTracker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loyaltyMetrics: [],
      notifications: [],
      loader: true,
      cardFlipped: false,
    };
  }

  async componentDidMount() {
    await this.getLoyaltyMetrics();
    await this.getNotifications();
    await this.readNotifications();
  }

  getNotifications = async () => {
    const notifications = await notificationRepo.getNotifications("campaign");

    this.setState({
      notifications: notifications?.data?.getNotifications
    });
  };

  readNotifications = async () => {
    const { notifications } = this.state;
    if(notifications?.length > 0) {
      const notificationIds = notifications.map(n => parseInt(n.id, 10));

      await notificationRepo.readNotifications(notificationIds);
    }
  };

  getLoyaltyMetrics = async () => {
    const response = await loyaltyRepo.getLoyaltyMetrics();
    this.setState({
      loyaltyMetrics: response.data.loyaltyMetrics,
      loader: false,
    });
  };

  renderLegacy() {

    const { points, redeemables } = this.props;
    const { loyaltyMetrics, notifications, loader } = this.state;

    const noRedeemables = !redeemables || redeemables.length <= 0;
    if(loader) {
      return <Loader />;
    }
    if (noRedeemables) {
      return null;
    }

    let pointsProgress = 0;
    const barProgress = 300 / redeemables.length / 2;

    if (points > redeemables[redeemables.length - 1].points) {
      pointsProgress = 297;
    } else {
      redeemables.forEach((item, index) => {
        const level = index + 1;
        if (!pointsProgress) {
          const userHasPointsLessThenLvlPoints =
            points > 0 && points <= item.points;
          if (userHasPointsLessThenLvlPoints) {
            if (index === 0) {
              pointsProgress = (points / item.points) * barProgress;
            } else {
              pointsProgress =
                ((points - (item.points - redeemables[0].points * level)) /
                  redeemables[0].points) *
                  barProgress +
                barProgress * index;
            }
          }
        }
      });
    }

    const notificationMessage = notifications?.length > 0 ? `+${(notifications?.length * 100) } for Referral` : '';

    return (
      <>
        <div
          className={`${legacyStyles.loyaltyPoints} mx-auto ly-8  px-4 flex gap-4 items-center bg-cover`}
        >
          <div className="w-[300px] h-[182px] flex flex-col gap-8 ">
            <div className="w-full flex flex-col gap-4">
              <p
                className="
                    font-congenialBlack text-4xl leading-9 tracking-[-1px] text-white hidden"
              >
                You have
                {' '}
                {points}
                <small className="!font-montserratMedium text-xl leading-[22px] tracking-[-0.3px]">
                  &nbsp;pts
                </small>
              </p>
              <h1
                className="
                    font-congenialBlack text-4xl mt-4 ml-4 leading-9 tracking-[-1px] text-white"
              >
                {points}
                <small className="!font-montserratMedium text-xl leading-[22px] tracking-[-0.3px]">
                  &nbsp;pts
                </small>
                <p className="!text-[#B4A5BB] !leading-5 !text-base !font-[425] !font-montserratMedium">
                  Rewards Points
                </p>
              </h1>
              <div>
                <p className="text-dryPink">{notificationMessage}</p>
              </div>
            </div>
            <div className="w-full">
              <div className="flex items-center flex-col justify-center absolute">
                <div className="mb-2 w-[300px]">
                  <Lottie animationData={mapPinAnimation} autoPlay loop style={{ marginLeft: `${pointsProgress - 15}px`, width:"30px", marginTop:"-25px" }} />
                </div>
                <div className="w-[300px] border-2 border-disabled rounded-[40px]">
                  <div
                    className="border-2 border-glow transition-all w-0 duration-500 ease-in-out rounded-full"
                    style={{ width: `${pointsProgress}px`}}
                  />
                </div>
                <div className="flex justify-between items-center relative top-[-9px]  w-[300px]">
                  {redeemables.map(item => (
                    <p
                      className={` ${
                        points >= item.points ? "bg-glow" : "bg-dark"
                      }
                        w-[14px] h-[14px] rounded-full 'border-disabled' border-2 mx-auto`}
                    />
                  ))}
                </div>
                <div
                  className="flex justify-between items-center
            absolute mt-11 w-[300px] text-white font-montserratMedium font-[425] text-base leading-5"
                >
                  {redeemables.map(item => (
                    <p className="mx-auto">{item.points}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-2 mt-8 mx-auto w-[343px]">
          {loyaltyMetrics.length > 0 &&
            loyaltyMetrics.map(metrics => {
              return (
                <div className="flex gap-3">
                  <div className={legacyStyles.loyaltyPointsCards}>
                    <p>{getMetricDisplayValue(metrics)}</p>
                    <p>{metrics.title}</p>
                  </div>
                </div>
              );
            })}
        </div>
      </>
    );
  }

  render() {
    const { brandRefresh } = this.props;
    if (!brandRefresh || !isBrandRefreshEnabled()) return this.renderLegacy();
    const { points, redeemables, barcode, barcodeStatus, onRetryBarcode, walletEnabled } = this.props;
    const { loyaltyMetrics, notifications, loader, cardFlipped } = this.state;
    const notificationMessage = notifications?.length > 0 ? `+${notifications.length * 100} for Referral` : "";

    return (
      <div className={brandStyles.hero}>
        <div className={brandStyles.mobileTitleBar}>
          <h1>Rewards</h1>
          <span className={brandStyles.mobilePointsBadge}>
            {Math.max(0, points || 0)}
            {' '}
            pts
          </span>
        </div>
        <div className={brandStyles.heroSummary}>
          <h1 className={brandStyles.pageTitle}>Rewards</h1>
          {loader ? <Loader /> : (
            <div className={`${brandStyles.metrics} ${cardFlipped ? brandStyles.mobileMetricsHidden : ""}`}>
              {(loyaltyMetrics || []).map((metrics, index) => (
                <React.Fragment key={metrics.type || metrics.title}>
                  {index > 0 && <span className={brandStyles.metricDivider} aria-hidden="true" />}
                  <div className={brandStyles.loyaltyPointsCards}>
                    <p>{getMetricDisplayValue(metrics)}</p>
                    <p>{metrics.title}</p>
                  </div>
                </React.Fragment>
              ))}
            </div>
          )}
          {notificationMessage && <p className={brandStyles.referralMessage}>{notificationMessage}</p>}
        </div>
        <LoyaltyCard
          points={points}
          redeemables={redeemables}
          barcode={barcode}
          barcodeStatus={barcodeStatus}
          onRetryBarcode={onRetryBarcode}
          walletEnabled={walletEnabled}
          onFlip={isFlipped => this.setState({ cardFlipped: isFlipped })}
        />
      </div>
    );
  }
}

LoyaltyPointTracker.propTypes = {
  brandRefresh: PropTypes.bool,
  points: PropTypes.number,
  redeemables: PropTypes.arrayOf(PropTypes.shape()),
  barcode: PropTypes.string,
  barcodeStatus: PropTypes.oneOf(["loading", "ready", "error"]),
  walletEnabled: PropTypes.bool,
  onRetryBarcode: PropTypes.func
};

LoyaltyPointTracker.defaultProps = {
  brandRefresh: false,
  walletEnabled: false,
  points: null,
  redeemables: null,
  barcode: null,
  barcodeStatus: "loading",
  onRetryBarcode: () => {}
};

export default LoyaltyPointTracker;
